const DEVICE_ID_KEY = 'device_id';

/**
 * Returns the persistent device ID for this browser.
 * Generates a UUID on first use and stores it in localStorage,
 * so subsequent calls always return the same value.
 */
export function getDeviceId() {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);

  if (!deviceId) {
    deviceId = generateUuid();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }

  return deviceId;
}

/**
 * Removes the stored device ID (e.g. when the device session is revoked).
 */
export function clearDeviceId() {
  localStorage.removeItem(DEVICE_ID_KEY);
}

function generateUuid() {
  // Use the browser crypto API when available (secure contexts)
  if (window.crypto && typeof window.crypto.randomUUID === 'function') {
    return window.crypto.randomUUID();
  }

  // Fallback for older browsers / non-secure contexts
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
